import { jwtDecode } from 'jwt-decode';
import { getRawRedirectParameters, removeToken } from '@/lib/oidc-client';
import { nativeStore } from './nativeStore';

type DecodedTokenT = Record<string, unknown>;

const MINUTE = 60 * 1000;
const DEFAULT_THRESHOLD = 3 * MINUTE;

export enum ValidationStatus {
  valid,
  expired,
  failed
}

export function decodeToken<T>(token: string) {
  return jwtDecode<T>(token);
}

function isExpired(token: string, threshold: number = DEFAULT_THRESHOLD) {
  const decoded = decodeToken<DecodedTokenT>(token);
  if (typeof decoded === 'undefined') return true;
  const exp = decoded.exp as number;

  const expTokenMs = exp * 1000 || 0;
  const isExpiredToken = expTokenMs - (Date.now() + threshold) <= 0;
  return !!isExpiredToken;
}

export function checkToken(
  token: string,
  handleError?: (error: IFeError) => void
): ValidationStatus {
  if (!token) {
    handleError?.({
      type: "Token doesn't exist",
      code: '',
      message: "Token doesn't exist"
    });
    return ValidationStatus.failed;
  }

  let status: ValidationStatus = ValidationStatus.valid;
  try {
    const isExpiredToken = isExpired(token);

    if (isExpiredToken) {
      status = ValidationStatus.expired;
    }
  } catch (error) {
    status = ValidationStatus.failed;
    handleError?.({
      type: 'request',
      code: error.code,
      message: error.message
    });
  }
  return status;
}

function urlProvider(name: string) {
  const baseParams = getRawRedirectParameters();
  const params = new URLSearchParams({
    ...baseParams,
    prompt: 'none',
    login_hint: name
  }).toString();

  return `${window.OIDC_BASE_URL}${window.OIDC_AUTH_ENDPOINT}?${params}`;
}

export function iframeProvider(name: string) {
  console.log('iframe provider');
  let iframe = document.getElementById('refresh');
  if (iframe === null) {
    iframe = document.createElement('iframe');
    iframe.setAttribute('id', 'refresh');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
  }
  const url = urlProvider(name);
  iframe.setAttribute('src', url);
}

function redirectToLogin() {
  if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
}

export async function updateInvalidToken() {
  await removeToken();
  if (nativeStore.redirectToSignout) {
    return;
  }
  redirectToLogin();
}

export const checkTokenUpdateSetting = (
  env: string | Record<string, unknown> = window.CUSTOM_ENV
) => {
  try {
    const { tokenUpdateEnabled = true } = typeof env === 'string' ? JSON.parse(env) : env;
    return tokenUpdateEnabled;
  } catch {
    return true;
  }
};
